<template>
  <q-table
    class="my-sticky-header-table no-border-radius shadow-1"
    :title="title"
    :data="records"
    :columns="columns"
    :pagination.sync="pagination"
    :filter="filter"
    :loading="loading"
    row-key="id"
    @row-click="onRowClick"
    @request="onRequest"
    :hide-header="hideHeader"
    :hide-bottom="hideBottom">

      <template v-slot:top>
        <slot name="top"></slot>
      </template>

      <template v-slot:body="props"  v-if="customBodySlot">
        <slot name="customBodySlot"  v-bind:row="props.row"></slot>
      </template>

      <template v-slot:body-cell-actions="props" v-if="customAction">
        <slot name="actions" v-bind:row="props.row"></slot>
      </template>
      <template v-slot:body-cell-actions="props" v-else>
        <q-td :props="props">
          <slot name="aditionalActions"  v-if="aditionalActions" v-bind:row="props.row"></slot>

          <q-btn flat round dense color="green" icon="visibility" class="q-ml-sm" @click="onClickView(props.row)" v-if="viewLink != ''">
            <q-tooltip>
            View
            </q-tooltip>
          </q-btn>

        </q-td>
      </template>
  </q-table>
</template>

<script>

export default {
  props: {
    title: String,
    dataStore: String,
    editRoute: {
      type: String,
      default: ''
    },
    customDelete: {
      type: Boolean,
      default: false
    },
    filter: Object,
    customCellTypes: [],
    rowClickable: {
      type: Boolean,
      default: false
    },
    visibleColumns: {
      type: Array,
      default: null,
    },
    viewLink:{
      type: String,
      default: '',
    },
    customAction: {
      default: false,
      type: Boolean
    },
    hasEditPermission: {
      default: false,
      type: Boolean
    },
    aditionalActions: {
      default: false,
      type: Boolean
    },
    canDelete: {
      default: true,
      type: Boolean
    },
    customBodySlot: {
      default: false,
      type: Boolean
    },
    hideHeader: {
      default: false,
      type: Boolean
    },
    hideBottom: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      pagination: {
        sortBy: 'created_at',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0
      },
      icon: 'list',
      unsubscribe: null,
    }
  },
 mounted() {
    this.$intercom.update({
    alignment: "left",
    });
},

  computed: {
    records(){
        return this.$store.getters[`${this.dataStore}/items`];
    },
    columns(){
        return this.$store.getters[`${this.dataStore}/columns`];
    },
    lastUpdated(){
        return this.$store.getters[`${this.dataStore}/lastUpdated`];
    },
  },
  methods: {
    onRequest(props){
        this.loading = true
        this.$store.dispatch(this.dataStore + "/getItems", props)
          .then(response => {
            if(this.hideBottom){
              let tableData = {};
              tableData.data = response.data;
              this.$store.commit(`${this.dataStore}/setTableData`, tableData);
              this.loading = false
            }else{
              // set data to proper variables
              this.pagination.page = response.data.current_page;
              this.pagination.rowsPerPage = response.data.per_page;
              this.pagination.rowsNumber = response.data.total;
              this.pagination.sortBy = props.pagination.sortBy
              this.pagination.descending = props.pagination.descending

              // create item object to update the store
              let tableData = {};
              tableData.pagination = this.pagination
              tableData.filter = this.filter
              tableData.data = response.data.data

              this.$store.commit(`${this.dataStore}/setTableData`, tableData);
              this.loading = false
            }


          })
          .catch(err => {
            this.loading = false
            console.error("ERROR LOADING DATA: ", err)
          })
      },
      onRowClick(evt, row){
        if(this.rowClickable)
          this.onClickView(row)
        else{
          return
        }
      },

    },
    created() {
        this.onRequest({
          pagination: this.pagination,
          filter: this.filter
        });

        this.unsubscribe = this.$store.subscribe((mutation, state) => {
          //check on which commit you need to reload this request
          if (mutation.type == this.dataStore + '/setLastUpdated'){
            //do your stuff here
            this.onRequest({
              pagination: this.pagination,
              filter: this.filter
            })
          }
        })
    },
    beforeDestroy() {
      this.unsubscribe()
       this.$intercom.update({
        alignment: "right",
       });
    },
  }
</script>
